document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll("a");

    links.forEach(function(link) {
      if (link.textContent.trim() === "Download Catalog") {
        link.addEventListener("click", function(e) {
          e.preventDefault();

          const fileUrl = "https://cdn.shopify.com/s/files/1/0675/9245/4420/files/Kepler_Brooks_Catalogue_2025_16dc0d5b-b2a2-41d5-b121-68c8c0e48123.pdf?v=1755889144";
          const fileName = "Kepler_Brooks_Catalog.pdf";

          fetch(fileUrl)
            .then(response => response.blob())
            .then(blob => {
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(url);
            })
            .catch(err => {
              console.error("Download failed:", err);
              alert("Unable to download the file. Please try again.");
            });
        });
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll("a");

    links.forEach(function(link) {
      if (link.textContent.trim() === "Download Guide") {
        link.addEventListener("click", function(e) {
          e.preventDefault();

          const fileUrl = "https://cdn.shopify.com/s/files/1/0675/9245/4420/files/Chairs_Adjustment_Guide.pdf?v=1755889159";
          const fileName = "Kepler_Brooks_Buying_Guide.pdf";

          fetch(fileUrl)
            .then(response => response.blob())
            .then(blob => {
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(url);
            })
            .catch(err => {
              console.error("Download failed:", err);
              alert("Unable to download the file. Please try again.");
            });
        });
      }
    });
  });

 

    document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".m-menu__item--dropdown").forEach(item => {
    const link = item.querySelector(".m-menu__link--main");
    const megaMenu = item.querySelector(".m-mega-menu");
    if (link && megaMenu) {
      // Get text like "Shop By"
      let text = link.textContent.trim();
      // Convert to lowercase, replace spaces with dashes -> "shop-by"
      let className = text.toLowerCase().replace(/\s+/g, "-");

      // Add class to mega menu
      megaMenu.classList.add(className);
      console.log("teddfasjknfjnfgjinsh");
    }
  });
});


// megamenu rendering start

let collectionlink = document.querySelector(".m-sub-menu__item.m-sub-menu__item--level-1.menu-collection-premium-chairs-mesh-chairs-leatherette-chairs-basic-chairs-boss-chairs-cafeteria-chairs-training-chairs-visitor-chairs-executive-chairs");
let sizelink = document.querySelector(".m-sub-menu__item.m-sub-menu__item--level-1.menu-size-mid-back-chairs-high-back-chairs");
let industrylink = document.querySelector(".m-sub-menu__item.m-sub-menu__item--level-1.menu-industry-offices-coworking-space-restaurants-banks-schools-hospitals-transit-areas");
let professionlink = document.querySelector(".m-sub-menu__item.m-sub-menu__item--level-1.menu-profession-doctors-teachers-executives-entrepreneurs-it-professionals-wfh-professionals");
let pricelink = document.querySelector(".m-sub-menu__item.m-sub-menu__item--level-1.menu-price-under-5k-5k-13k-above-13k");
let hidemenusize = document.querySelector(".m-sub-menu.m-sub-menu--level-2.menu-premium-chairs-mesh-chairs-leatherette-chairs-basic-chairs-boss-chairs-cafeteria-chairs-training-chairs-visitor-chairs-executive-chairs");
let topmenusize = document.querySelector(".m-sub-menu.m-sub-menu--level-2.menu-mid-back-chairs-high-back-chairs");
let shopby = document.querySelector("li.m-menu__item.m-menu__item--parent.m-menu__item--has-submenu.m-menu__item--dropdown.rp_shop-by");

collectionlink.addEventListener('mouseover', ()=>{
  hidemenusize.style.display = "grid";
})

sizelink.addEventListener('mouseover',()=>{
  hidemenusize.style.display = 'none';
})

industrylink.addEventListener('mouseover',()=>{
   hidemenusize.style.display = 'none';
})

professionlink.addEventListener('mouseover',()=>{
   hidemenusize.style.display = 'none';
})

pricelink.addEventListener('mouseover',()=>{
   hidemenusize.style.display = 'none';
})

sizelink.addEventListener('mouseout',()=>{
  hidemenusize.style.display = 'grid';
})

// mega-menu rendering end